import {ToggleScroll} from './toggle-scroll';

const TIMEOUT_HIDE_INFO_MESSAGE = 3000;

/** Компонент модала. */
export class Modal {
  /**
   * Создаёт компонент модала.
   *
   * @param {HTMLElement} el Родительский элемент модала (элемент заднего фона).
   */
  constructor(el) {
    this.el = el;
    this.isClose = false;
    this.bindEventListeners();
    if (this.el.classList.contains('js-modal-opened')) {
      Modal.open(this.el);
    }
  }

  /**
   * Вешает колбеки закрытия модала.
   *
   * @returns {void}
   */
  bindEventListeners() {
    this.el.addEventListener('mousedown', (e) => {
      if (
        !e.target.closest('.js-modal-dialog') ||
        e.target.classList.contains('js-modal-close') ||
        e.target.closest('.js-modal-close')
      ) {
        Modal.close(this.el);
      }
    });

    this.el.addEventListener('mouseup', (e) => e.stopPropagation());
    this.el.addEventListener('touchend', (e) => e.stopPropagation());

    document.addEventListener('keydown', (e) => {
      const keyName = e.key;
      if ((keyName === 'Escape' || keyName === 'Esc') && this.el.classList.contains('visible')) {
        Modal.close(this.el);
      }
    });
  }

  /**
   * Закрывает модал.
   *
   * @param {HTMLElement} modal Главный элемент модала.
   * @returns {void}
   */
  static close(modal) {
    modal.classList.remove('visible');
    ToggleScroll.enable(modal);
    this.isClose = true;
  }

  /**
   * Открывает модал.
   *
   * @param {Element} modal Главный элемент модала.
   * @returns {void}
   */
  static open(modal) {
    modal.classList.add('visible');
    ToggleScroll.disable(modal);
    this.isClose = false;

    const input = modal.querySelector('input');
    if (input) {
      input.focus();
    }

    if (modal.classList.contains('js-modal-autoclose')) {
      Modal.autoclose(modal);
    }
  }

  /**
   * Закртыть модал по таймауту.
   *
   * @param {Element} modal Главный элемент модала.
   * @returns {void}
   */
  static autoclose(modal) {
    setTimeout(() => {
      if (!this.isClose) {
        Modal.close(modal);
      }
    }, TIMEOUT_HIDE_INFO_MESSAGE);
  }

  /**
   * Показать модал с ошибкой.
   *
   * @param {string} message Текст ошибки.
   * @returns {void}
   */
  static showErrorModal(message = '') {
    const modalError = document.querySelector(".js-modal[data-modal-name='error']");
    if (modalError) {
      if (message) {
        modalError.querySelector('.js-modal-error').innerHTML = message;
      }
      Modal.open(modalError);
    }
  }
}

document.querySelectorAll('.js-modal').forEach((el) => new Modal(el));
